import { useCallback, useRef, useState } from 'react';
import { ModalType } from './modalType';
export const defaultState = {
  modals: {
    [ModalType.MANDATORY]: [],
    [ModalType.OTHER]: []
  }
};
export function useModalManagerState() {
  const modalStateRef = useRef(defaultState);
  const [_, rerender] = useState(0);
  const register = useCallback(_register, [rerender]);
  const shouldRender = useCallback(_shouldRender, []);
  const unregister = useCallback(_unregister, [rerender]);
  const isIdRegistered = useCallback(_isAlreadyRegistered, []);
  return {
    state: modalStateRef.current,
    modals: modalStateRef.current.modals,
    isIdRegistered,
    register,
    unregister,
    shouldRender
  };
  function _register(type, id) {
    const modals = modalStateRef.current.modals;
    const isAlreadyRegistered = modals[type].includes(id);
    if (isAlreadyRegistered) {
      throw new Error("Modal of type=\"" + type + "\" with id=\"" + id + "\" was already registered.");
    }
    modalStateRef.current.modals[type].push(id);
    rerender(p => p + 1);
  }
  function _unregister(type, id) {
    const index = modalStateRef.current.modals[type].findIndex(modalId => modalId === id);
    if (index >= 0) {
      modalStateRef.current.modals[type].splice(index, 1);
      rerender(p => p - 1);
    }
  }
  function _shouldRender(type, id) {
    const modals = modalStateRef.current.modals;
    if (!modals[type].includes(id)) {
      return false;
    }

    // First render mandatory modals, starting from the first registered modal
    if (type === ModalType.MANDATORY) return modals[ModalType.MANDATORY][0] === id;

    // Render all other modals
    return modals[ModalType.MANDATORY].length === 0;
  }
  function _isAlreadyRegistered(type, id) {
    return modalStateRef.current.modals[type].includes(id);
  }
}